__turbopack_context__.v({
  "dashboardTreeContainer": "dashboard-module__wIZYGG__dashboardTreeContainer",
  "outerContainer": "dashboard-module__wIZYGG__outerContainer",
});
